// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
}

.forgot-illustration-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.forgot-illustration {
  max-width: 65%;
  height: auto;
  border-radius: 50%;
}

.popup {
  border-radius: 20px !important;
}

.popup-content {
  width: 520px;
  padding: 56px 48px;
  text-align: center;
  font-family: "Work Sans", sans-serif;
}

.popup-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  border-radius: 50%;
  background-color: rgba(25, 118, 210, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-icon-wrapper svg {
  font-size: 44px;
  color: #1976d2;
}

.popup-content h2 {
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 12px;
}

.popup-content p {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.7;
  margin-bottom: 32px;
}

.login-ctx {
  width: 100%;
  margin-top: 16px !important;
  padding: 12px 16px !important;
  border-radius: 10px !important;
  background: transparent !important;
  text-transform: none !important;
  font-weight: 600 !important;
  color: #6b7280 !important;
  border: 1px solid #3f6675 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;AACtC","sourcesContent":[".form-subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 24px;\n}\n\n.forgot-illustration-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.forgot-illustration {\n  max-width: 65%;\n  height: auto;\n  border-radius: 50%;\n}\n\n.popup {\n  border-radius: 20px !important;\n}\n\n.popup-content {\n  width: 520px;\n  padding: 56px 48px;\n  text-align: center;\n  font-family: \"Work Sans\", sans-serif;\n}\n\n.popup-icon-wrapper {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 24px;\n  border-radius: 50%;\n  background-color: rgba(25, 118, 210, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.popup-icon-wrapper svg {\n  font-size: 44px;\n  color: #1976d2;\n}\n\n.popup-content h2 {\n  font-size: 26px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.popup-content p {\n  font-size: 15px;\n  color: #6b7280;\n  line-height: 1.7;\n  margin-bottom: 32px;\n}\n\n.login-ctx {\n  width: 100%;\n  margin-top: 16px !important;\n  padding: 12px 16px !important;\n  border-radius: 10px !important;\n  background: transparent !important;\n  text-transform: none !important;\n  font-weight: 600 !important;\n  color: #6b7280 !important;\n  border: 1px solid #3f6675 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
